export default class {
	constructor(obj) {
		this.id = obj.id
		this.title = obj.title
		this.pic = obj.pic
		this.layers = obj.layers
		this.siteTypes = obj.siteTypes
		this.masterTheme = obj.masterTheme
		this.color = obj.color
		this.disable = obj.disable
	}
}



// WEBPACK FOOTER //
// ./src/administration/dto/ThemeDto.js